'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    @media (min-width: ', 'px) {\n      ', ';\n    }\n  '], ['\n    @media (min-width: ', 'px) {\n      ', ';\n    }\n  ']);

var _polished = require('polished');

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sizes = {
  xl: 1600,
  l: 1200,
  m: 992,
  s: 768,
  xs: 480
};

var media = {
  xs: function xs() {
    return (0, _styledComponents.css)(_templateObject, sizes.xs, _styledComponents.css.apply(undefined, arguments));
  },
  s: function s() {
    return (0, _styledComponents.css)(_templateObject, sizes.s, _styledComponents.css.apply(undefined, arguments));
  },
  m: function m() {
    return (0, _styledComponents.css)(_templateObject, sizes.m, _styledComponents.css.apply(undefined, arguments));
  },
  l: function l() {
    return (0, _styledComponents.css)(_templateObject, sizes.l, _styledComponents.css.apply(undefined, arguments));
  },
  xl: function xl() {
    return (0, _styledComponents.css)(_templateObject, sizes.xl, _styledComponents.css.apply(undefined, arguments));
  }
};

var color = {
  newTextColor: '#555555',
  textColor: '#000000',
  primary: '#70af00',
  primaryBg: '#FFFFFF',
  gray: '#3e3c3c',
  black: '#000000',
  white: '#FFFFFF',
  danger: '#f05c63',
  dangerBg: 'rgba(255,0,0,0.1)',
  dangerPopup: 'rgba(255,0,0,0.5)',
  success: '#5bd084',
  disabled: '#eee',
  inactiveColor: '#d3d7d9',
  inactiveTextColor: '#adadad',
  separatorColor: '#cccccc',
  footerBg: '#eff0f3',
  copryrightTextColor: '#a8a8a8'
};

var font = {
  lineHeight: 1.5,
  fontFamily: '\'Roboto\', sans-serif',
  fontSizeXXS: (0, _polished.rem)(12),
  fontSizeXS: (0, _polished.rem)(14),
  fontSizeS: (0, _polished.rem)(16),
  fontSizeM: (0, _polished.rem)(20),
  fontSizeL: (0, _polished.rem)(24),
  fontSizeXL: (0, _polished.rem)(30)
};

var heading = {
  fontWeight: '700',
  fontFamily: font.fontFamily,
  lineHeight: font.lineHeight,
  fontSize: {
    h1: font.fontSizeXL,
    h2: font.fontSizeXL,
    h3: font.fontSizeL
  }
};

var header = {
  primaryBg: color.primaryBg,
  secondaryBg: '#f1f1f1'
};

var mainMenu = {
  backgroundColor: '#d2d2d2',
  subsectionBackgroundColor: color.primaryBg,
  linkColor: color.textColor,
  borderColor: '#c2ccd5',
  submenuTextColor: '#656565'
};

var form = {
  labelColor: color.base,
  placeholderColor: '#d4d4d4',
  disabledFormColor: color.inactiveTextColor,
  searchBorderColor: '#5d5d5d'
};

var table = {
  tableBg: color.primaryBg,
  separatorColor: '#a8b0b5',
  hover: '#f2f7e9',
  oddRowBg: '#f2f6fa',
  thSeparatorColor: '#a4d9e9',
  inactiveColor: '#f6f6f6',
  inactiveTextColor: '#a09f9f'
};

var grid = {
  rowMargin: '0 ' + (0, _polished.rem)(-5) + ' ' + (0, _polished.rem)(15),
  colPadding: '0 ' + (0, _polished.rem)(5)
};

var segment = {
  priamryPadding: (0, _polished.rem)(25) + ' ' + (0, _polished.rem)(20),
  secondaryPadding: '' + (0, _polished.rem)(20),
  primaryBg: '#e9edf0',
  secondaryBg: '#f5f5f5',
  secondaryBorderColor: color.separatorColor
};

var card = {
  contentBg: '#f2f6fa',
  secondaryContentBg: color.primaryBg,
  contentPadding: (0, _polished.rem)(5) + ' 0',
  label: {
    textColor: color.white,
    bgColor: '#e2574c',
    fontFamiy: font.fontFamily,
    fontWeight: '400'
  }
};

var actionMenu = {
  borderColor: '#dee3e8',
  borderColorMobile: '#555454',
  mobileHoverBg: '#4d4b4b',
  fontFamilyMobile: font.fontFamily
};

var theme = {
  heading: heading,
  color: color,
  font: font,
  header: header,
  mainMenu: mainMenu,
  form: form,
  table: table,
  media: media,
  grid: grid,
  segment: segment,
  card: card,
  actionMenu: actionMenu,
  textColor: color.textColor,
  largeBorderRadius: (0, _polished.rem)(4),
  separatorColor: '#eee',
  shadow: '0 ' + (0, _polished.rem)(3) + ' ' + (0, _polished.rem)(12) + ' rgba(29, 113, 184, 0.5)',
  focusShadow: '0 0 1px 1px ' + color.primary + '66',
  smallShadow: '0 ' + (0, _polished.rem)(2) + ' ' + (0, _polished.rem)(4.55) + ' ' + (0, _polished.rem)(0.45) + ' rgba(1, 1, 1, 0.07)',
  shadowInactive: '0 ' + (0, _polished.rem)(3) + ' ' + (0, _polished.rem)(12) + ' rgba(204, 204, 204, 1)',
  border: '2px solid ' + color.primary
};

exports.default = theme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Themes/baseTheme.js
// module id = 37
// module chunks = 1